import axios from "../axios-auth";
import orginal_axios from "axios";

export const accountPayableService = {
    getAccountPayableList,
    getAllAccountPayableList,
    getAccountPayableDetail,
    showWindowDialog,
    exportAllAccountPayableDetailExcel,
    saveAccountPayable,
    getAccountPayableReport,
    getAllAccountPayableReportPrint,
    getAccountPayableReportBySupplier,
    getAllAccountPayableReportBySupplierPrint,
    getAccountPayableReportBySupplierExcelExport,
    getAccountPayableFinanceSummaryReport,
    getPurchaseAmountFinanceDetail,
    getPurchaseDiscountAmountFinanceDetail,
    getPurchaseReturnAmountFinanceDetail,
    getPurchaseReturnDiscountAmountFinanceDetail,
    getPurchasePaymentAmountFinanceDetail,
    getPurchaseAmountFinanceDetailExcelExport,
    getUnpaidSupplierAdvancedTypeAccountPayableList
};

function getAccountPayableList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.supplierName) {
        params["supplierName"] = searchParams.supplierName;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.shopName) {
        params["shopName"] = searchParams.shopName;
    }
    if (searchParams.apType) {
        params["apType"] = searchParams.apType;
    }
    if (searchParams.chequeNo) {
        params["chequeNo"] = searchParams.chequeNo;
    }
    return axios.get("/auth/account-payables", { params });
}

function getAllAccountPayableList(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.supplierName) {
        params["supplierName"] = searchParams.supplierName;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.shopName) {
        params["shopName"] = searchParams.shopName;
    }
    if (searchParams.apType) {
        params["apType"] = searchParams.apType;
    }
    if (searchParams.chequeNo) {
        params["chequeNo"] = searchParams.chequeNo;
    }

    return axios.get("/auth/account-payables", { params });
}

function getAccountPayableDetail(id) {
    return axios.get("/auth/account-payable/" + id);
}

function saveAccountPayable(accountPayable) {
    if (!accountPayable.id) {
        // new accountpayable
        return axios.post("/auth/account-payable", accountPayable);
    } else {
        // edit
        return axios.put("/auth/account-payable", accountPayable);
    }
}

function exportAllAccountPayableDetailExcel(searchParams) {
    let params = {
    };
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.supplierName) {
        params["supplierName"] = searchParams.supplierName;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.shopName) {
        params["shopName"] = searchParams.shopName;
    }
    if (searchParams.apType) {
        params["apType"] = searchParams.apType;
    }
    if (searchParams.chequeNo) {
        params["chequeNo"] = searchParams.chequeNo;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/all-account-payable-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function showWindowDialog(blob, fileName) {
    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob);
        return;
    }
    // For other browsers: 
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL(blob);
    var link = document.createElement(fileName);
    link.href = data;
    link.download = fileName + ".pdf";
    window.open(link.href, fileName, "width=500,height=500");

    setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
    }, 100);
}

function getAccountPayableReport(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.supplierIds) {
        params["supplierIds"] = searchParams.supplierIds.join();
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.apType) {
        params["apType"] = searchParams.apType;
    }

    return axios.get("/auth/account-payable-report", { params });
}

function getAllAccountPayableReportPrint(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.supplierIds) {
        params["supplierIds"] = searchParams.supplierIds.join();
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo.join();
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.apType) {
        params["apType"] = searchParams.apType;
    }

    return axios.get("/auth/account-payable-report-print", { params });
}


function getAccountPayableReportBySupplier(searchParams, page, size, sortedBy) {
    let url = '';
    let params = {};
    
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    if (sortedBy == 'null,asc') {
        url = '/auth/account-payable-report-by-supplier?page=' + page + '&size=' + size;
    } else {
        url = '/auth/account-payable-report-by-supplier?page=' + page + '&size=' + size + '&sort=' + sortedBy;
    }

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.dateFilter) {
        params["dateFilter"] = searchParams.dateFilter;
    }
    if (searchParams.supplierCode) {
        params["supplierCode"] = searchParams.supplierCode;
    }
    if (searchParams.supplierName) {
        params["supplierName"] = searchParams.supplierName;
    }
    if (searchParams.currencyId) {
        params["currencyId"] = searchParams.currencyId;
    }
    if (searchParams.warehouseIds) {
        params["warehouseIds"] = searchParams.warehouseIds.join();
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.poNo) {
        params["poNo"] = searchParams.poNo;
    }

    return axios.get(url, { params });
}

function getAllAccountPayableReportBySupplierPrint(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.supplierCode) {
        params["supplierCode"] = searchParams.supplierCode;
    }
    if (searchParams.supplierName) {
        params["supplierName"] = searchParams.supplierName;
    }
    if (searchParams.currencyId) {
        params["currencyId"] = searchParams.currencyId;
    }
    if (searchParams.warehouseIds) {
        params["warehouseIds"] = searchParams.warehouseIds.join();
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.poNo) {
        params["poNo"] = searchParams.poNo;
    }

    return axios.get("/auth/account-payable-report-by-supplier", { params });
}

function getAccountPayableReportBySupplierExcelExport(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.supplierCode) {
        params["supplierCode"] = searchParams.supplierCode;
    }
    if (searchParams.supplierName) {
        params["supplierName"] = searchParams.supplierName;
    }
    if (searchParams.currencyId) {
        params["currencyId"] = searchParams.currencyId;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/account-payable-report-by-supplier-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function getAccountPayableFinanceSummaryReport(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.supplierIds) {
        params["supplierIds"] = searchParams.supplierIds.join();
    }
    return axios.get("/auth/account-payable-finance-summary-report", { params });

}

function getPurchaseAmountFinanceDetail(searchParams, page, size, sortedBy) {

    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.supplierIds) {
        params["supplierIds"] = searchParams.supplierIds.join();
    }
    return axios.get("/auth/purchase-amount-finance-detail", { params });
}

function getPurchaseDiscountAmountFinanceDetail(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.supplierIds) {
        params["supplierIds"] = searchParams.supplierIds.join();
    }
    return axios.get("/auth/purchase-discount-amount-finance-detail", { params });
}

function getPurchaseReturnAmountFinanceDetail(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.supplierIds) {
        params["supplierIds"] = searchParams.supplierIds.join();
    }
    return axios.get("/auth/purchase-return-amount-finance-detail", { params });
}

function getPurchaseReturnDiscountAmountFinanceDetail(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.supplierIds) {
        params["supplierIds"] = searchParams.supplierIds.join();
    }
    return axios.get("/auth/purchase-return-discount-amount-finance-detail", { params });
}

function getPurchasePaymentAmountFinanceDetail(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.supplierIds) {
        params["supplierIds"] = searchParams.supplierIds.join();
    }
    return axios.get("/auth/purchase-payment-amount-finance-detail", { params });
}

function getPurchaseAmountFinanceDetailExcelExport(searchParams, detailType) {
    let params = {
    };
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (detailType) {
        params["detailType"] = detailType;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/purchase-finance-report-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function getUnpaidSupplierAdvancedTypeAccountPayableList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }

    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }

    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }

    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }

    if (searchParams.supplierId) {
        params["supplierId"] = searchParams.supplierId;
    }

    if (searchParams.currencyId) {
        params["currencyId"] = searchParams.currencyId;
    }

    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }

    return axios.get("/auth/confirm-unpaid", { params });
}